import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import TimeSlotsContainer from "../../../../TimeSlots/v3/components/TimeSlots/TimeSlotsContainer.js";
import AppointmentPickDifferentTimeSlotLoading from "./AppointmentPickDifferentTimeSlotLoading.js";
import AppointmentPickDifferentTimeSlotNotAvailable from "./AppointmentPickDifferentTimeSlotNotAvailable.js";
const AppointmentPickDifferentTimeSlotContent = ({
  labels,
  loading,
  timeSlots,
  onSelectTimeSlot,
  selected,
  onClickPrevious
}) => {
  if (loading) {
    return /* @__PURE__ */ React.createElement(AppointmentPickDifferentTimeSlotLoading, { labels });
  }
  if (timeSlots.length === 0) {
    return /* @__PURE__ */ React.createElement(AppointmentPickDifferentTimeSlotNotAvailable, { labels, onClickPrevious });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", null, labels.selectATime), /* @__PURE__ */ React.createElement(Text, { color: "text-secondary" }, labels.selectATimeSubtitle), /* @__PURE__ */ React.createElement(
    TimeSlotsContainer,
    {
      className: "appointment-pick-different-time-slot__slots",
      loading,
      slots: timeSlots,
      onSelectTime: onSelectTimeSlot,
      selected: selected ?? void 0
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "appointment-pick-different-time-slot__previous",
      onClick: onClickPrevious,
      type: "button"
    },
    /* @__PURE__ */ React.createElement(Text, { variant: "link", className: "appointment-pick-different-time-slot__link" }, labels.selectAnotherDay)
  ));
};
export {
  AppointmentPickDifferentTimeSlotContent as default
};
//# sourceMappingURL=AppointmentPickDifferentTimeSlotContent.js.map
